module.exports = __webpack_public_path__ + "img/yonghu.0501a537.png";